import React from 'react';
import { HashLink as NavLink } from 'react-router-hash-link';
import { isInternalURL } from '@plone/volto/helpers';
import config from '@plone/volto/registry';

const NavItem = ({ item }) => {
  const { settings } = config;

  if (isInternalURL(item.url) || item.url === '') {
    return (
      <NavLink
        to={item.url === '' ? '/' : item.url}
        key={item.url}
        className="item"
        smooth
      >
        {item.title}
      </NavLink>
    );
  } else {
    return (
      <a
        href={item.url}
        key={item.url}
        className="item"
        rel="noopener noreferrer"
        target={settings.openExternalLinkInNewTab ? '_blank' : '_self'}
      >
        {item.title}
      </a>
    );
  }
};

export default NavItem;
